import { CustomApplicationActions } from "@MasterBluePrint/Store/CustomApplicationState";
import { PiyoviAddressType } from "@MasterBluePrint/Store/Components/CustomCheckoutShipping/CustomCheckoutShippingState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

interface Parameter {
    addressType: PiyoviAddressType;
    isBypassing: boolean;
}

type HandlerType = Handler<Parameter, DispatchProp<CustomApplicationActions>>;

export const DispatchSetBypassPiyoviByType: HandlerType = props => {
    props.dispatch({
        type: "Components/CustomCheckoutShipping/SetBypassPiyoviByType",
        addressType: props.parameter.addressType,
        isBypassing: props.parameter.isBypassing,
    });
};

export const chain = [DispatchSetBypassPiyoviByType];

const setBypassPiyoviByType = createHandlerChainRunner(chain, "SetBypassPiyoviByType");
export default setBypassPiyoviByType;
